export const locationRegex = new RegExp(/\w{1,}/g)